import { Modal } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import CloseWindowButton from '../../../../atomic/buttons/closeWindow/CloseWindowButton';
import style from './ImportModal.module.css';
import PropTypes from 'prop-types';
import TextButton from '../../../../atomic/buttons/textButton/TextButton';
//import { getImportTemplateSubject } from '../../../../../znotusedcurrently/rxjs/subjects/importexport/ImportTemplateSubject.js1';
import { importTradePlan } from '../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/importexporttradeplan/importTradePlan';
import { observer } from 'mobx-react-lite';
import { useWebsocketStore } from '../../../../../stores/websocketStore/websocketProvider';

const ImportModal = observer(({ open, handleClose, handleLoad }) => {
  const [inputVal, setInputVal] = useState('');
  const [templateInfo, setTemplateInfo] = useState({});
  const [error, setError] = useState(false);
  const { importTemplateSubject } = useWebsocketStore();
  const resetState = () => {
    setInputVal('');
    setTemplateInfo({});
    setError(false);
  };

  useEffect(() => {
    const sub = importTemplateSubject.subscribe((info) => {
      if (info.type === 'error') setError(info.reason);
      else setTemplateInfo(info);
    });
    return () => {
      sub.unsubscribe();
    };
  }, []);
  useEffect(() => {
    setError(false);
  }, [inputVal]);

  return (
    <Modal
      open={open}
      onClose={() => {
        handleClose();
        resetState();
      }}
      onBackdropClick={() => {
        handleClose();
        resetState();
      }}
    >
      <div className={style.importModalContainer}>
        <CloseWindowButton
          width={20}
          stroke={2}
          color="black"
          handleClick={() => {
            handleClose();
            resetState();
          }}
        />
        <div className={style.innerContainer}>
          <h5 className={style.header}>Import Template</h5>
          <div className={style.copy}>
            <p>
              Import another user&apos;s template by entering the template code
              below then loading the template into your trade plan form.
            </p>
          </div>
          <div className={style.input}>
            <input
              type="text"
              value={inputVal}
              onChange={({ target }) => setInputVal(target.value)}
              placeholder="Enter template code..."
            />
            <TextButton
              fontSize="medium"
              clickHandler={() => {
                importTradePlan({ hash: inputVal });
              }}
              color="white"
              backgroundColor="blue"
              width="60px"
            >
              Import
            </TextButton>
          </div>
          <p className={style.error}>{error ? error : ''}</p>
          <div className={style.templateInfo}>
            <h6 className={style.title}>
              {' '}
              <span className={style.bold}>Template title:</span>{' '}
              {templateInfo?.templateName}
            </h6>
            <h6 className={style.date}>
              <span className={style.bold}>Created: </span>{' '}
              {new Date(templateInfo?.timestamp).toDateString() ===
              'Invalid Date'
                ? ''
                : new Date(templateInfo?.timestamp).toDateString()}
            </h6>
            <p className={style.description}>
              <span className={style.bold}>Description: </span>
              {templateInfo?.description}
            </p>
            <div className={style.existingTagDiv}>
              {templateInfo?.tags?.map((tag) => (
                <span className={style.existingTags} key={tag}>
                  {tag}
                </span>
              ))}
            </div>
          </div>
          <TextButton
            fontSize="medium"
            clickHandler={() => {
              handleLoad(templateInfo.template);
              resetState();
              handleClose();
            }}
            color="white"
            backgroundColor="blue"
            width="100%"
          >
            Load Template to Form
          </TextButton>
        </div>
      </div>
    </Modal>
  );
});
ImportModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleLoad: PropTypes.func.isRequired,
};

export default ImportModal;
